import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextIndicator: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTextIndicator"><Path fillRule="evenodd" clipRule="evenodd" d="M16 2H22V3.5H19.75V20.5H22V22H16V20.5H18.25V3.5H16V2ZM2 5H14V6.5H8.75V19H7.25V6.5H2V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextIndicator;
